import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const ListOfDoctorsBlock = () => {
  return (
    <>
      <div className="row justify-content-start">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <h2>List of Doctors</h2>
        </div>
        <div className="pt-2 kmc-p-content">
          <b>
            Please book a prior appointment to secure your preferred time slot.
          </b>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dr-kishore-12.png"
            alt="Dr. Kishore Sabbu"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/check-h.png"
                alt="Dr. Kishore Sabbu"
              />
            </div>
            <ul className="list-heading pt-3">
              <li>
                <a href=" # ">
                  <StaticImage
                    className="doctor_linkedin"
                    src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                    alt="linkedin"
                  />
                </a>
              </li>
              <li>
                <span className="list-timeInOut">
                  <StaticImage
                    className="doctor_Group"
                    src="../../../assets/images/kmc-images/Doctors/circle-clock-new.png"
                    alt="Group7125"
                  />
                  9 AM - 5 PM
                </span>
              </li>
            </ul>
            <div className="list-heading-one pt-3">Consultant Physician</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Kishore Sabbu M.B.B.S, D.C.H, M.D. (Internal medicine)
            </div>
            <p className="pt-3">Diabetologist, Pediatrician</p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dr-vidhya-12.png"
            alt="Dr Vidyavathi Vanapalli"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/scope-s.png"
                alt="Dr Vidyavathi Vanapalli"
              />
            </div>
            <div className="list-heading pt-3">
              <ul className="list-heading">
                <li>
                  <a href=" # ">
                    <StaticImage
                      className="doctor_linkedin"
                      src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                      alt="linkedin"
                    />
                  </a>
                </li>
                <li>
                  <span className="list-timeInOut">
                    <StaticImage
                      className="doctor_Group"
                      src="../../../assets/images/kmc-images/Doctors/circle-clock-new.png"
                      alt="Group7125"
                    />
                    9 AM - 5 PM
                  </span>
                </li>
              </ul>
            </div>
            <div className="list-heading-one pt-3">Consultant Pathologist</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Vidyavathi Vanapalli M.B.B.S, M.D.
            </div>
            <p className="pt-3"> Pathology</p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dc_vishnu.png"
            alt="Dr Sharath Reddy Annam"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/check-h.png"
                alt="Dr K Vishnu Vardhan"
              />
            </div>
            <div className="list-heading pt-3">
              <ul className="list-heading">
                <li>
                  <span className="list-timeInOut">
                    <StaticImage
                      className="doctor_Group"
                      src="../../../assets/images/kmc-images/Doctors/circle-clock-new.png"
                      alt="Group7125"
                    />
                    9 AM to 4 PM & 6 pm to 8 pm
                  </span>
                </li>
              </ul>
            </div>
            <div className="list-heading-one pt-3">Family Physician</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. (Lt.Col) K. Vishnu Vardhan MD (RUS), DNB (Family Medicine)
            </div>
            <p className="pt-3">
              Expertise in managing NCD AND CD, trained in managing Core
              pediatric conditions relating to nutrition growth and development
              immunisation infections, and trained in handling ANC and
              gynecological conditions.
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dr_lalit.png"
            alt="Dr Lalit Mohan Singh"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/teeth-t.png"
                alt="Dr Lalit Mohan Singh"
              />
            </div>
            <div className="list-heading pt-3">
              <ul className="list-heading">
                <li>
                  <a href=" # ">
                    <StaticImage
                      className="doctor_linkedin"
                      src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                      alt="linkedin"
                    />
                  </a>
                </li>
                <li>
                  <span className="list-timeInOut">
                    <StaticImage
                      className="doctor_Group"
                      src="../../../assets/images/kmc-images/Doctors/circle-clock-new.png"
                      alt="Group7125"
                    />
                    9 AM - 5 PM
                  </span>
                </li>
              </ul>
            </div>
            <div className="list-heading-one pt-3">Dental Consultant</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Lalit Mohan Singh B.D.S.
            </div>
            <p className="pt-3">
              This centre includes a dental unit attending to all the basic
              dental issues.
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dr-nandlal-img.png"
            alt="Dr Nandlal Beswal"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/box-h.png"
                alt="Dr Nandlal Beswal"
              />
            </div>
            <div className="list-heading pt-3">
              <ul className="list-heading">
                <li>
                  <a href=" # ">
                    <StaticImage
                      className="doctor_linkedin"
                      src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                      alt="linkedin"
                    />
                  </a>
                </li>
                <li>
                  <span className="list-timeInOut">
                    <StaticImage
                      className="doctor_Group"
                      src="../../../assets/images/kmc-images/Doctors/circle-clock-new.png"
                      alt="Group7125"
                    />
                    On call
                  </span>
                </li>
              </ul>
            </div>
            <div className="list-heading-one pt-3">Consultant Surgeon</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Nandlal Beswal F.R.C.S.
            </div>
            {/* <p className="pt-3"></p> */}
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dr-sasitry.png"
            alt="Dr Sharath Reddy Annam"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/check-h.png"
                alt="Dr Srinivasa Shastry"
              />
            </div>
            <div className="list-heading pt-3">
              <ul className="list-heading">
                <li>
                  <a
                    href="https://www.linkedin.com/in/drsharathreddy/?originalSubdomain=in"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <StaticImage
                      className="doctor_linkedin"
                      src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                      alt="linkedin"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="list-heading-one pt-3">Visiting Consultant</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">
              Dr. Sharath Reddy Annam M.D., D.M., F.S.C.A.I., F.A.C.C.,
              F.A.H.A., J.A.C.C.,
            </div>
            <p className="pt-3">
              Sr. Consultant Interventional Cardiologist, Executive Director &
              Director-CathLab, Proctor for CTO, Complex Coronary Interventions
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3 my-2 doctors-lists">
          <StaticImage
            className="doctor-auth"
            src="../../../assets/images/kmc-images/Doctors/dc_Vijay.png"
            alt="Dr Sharath Reddy Annam"
            style={{ height: "300px" }}
          />
          <div className="bg-light services-lists">
            <div className="text-center">
              <StaticImage
                className="doctor-auth1"
                src="../../../assets/images/kmc-images/Doctors/check-h.png"
                alt="Dr Srinivasa Shastry"
              />
            </div>
            <div className="list-heading-one pt-3">Visiting Consultant</div>
            <div className="list-hr" />
            <div className="list-doctorName pt-3">Dr. Vijay (MD) Russia</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfDoctorsBlock;
